import { graphql, useStaticQuery } from "gatsby";
import { StaticDestinationsDataQuery } from "types/graphql-types";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import {
  LocalizedStaticQueryResult,
  localizeStaticQuery
} from "./localizeStaticQuery";

export type UseStaticDestinationDataReturn = LocalizedStaticQueryResult<
  StaticDestinationsDataQuery["destinations"]["nodes"][0]
>[];

export interface useStaticDestinationsDataArgs {
  showExpeditionsOnly?: boolean;
}

const useStaticDestinationsData = ({
  showExpeditionsOnly = false
}: useStaticDestinationsDataArgs): UseStaticDestinationDataReturn => {
  const language = useLanguage();
  const { destinations } = useStaticQuery<StaticDestinationsDataQuery>(
    graphql`
      query StaticDestinationsData {
        destinations: allSanityDestination(
          sort: { order: ASC, fields: card___title___en }
        ) {
          nodes {
            _id
            id
            destinationId
            isExpeditionDestination
            card {
              ...AsCardForStaticQuery
            }

            fullPath
            i18nFullPaths
            metadata {
              tracking {
                name
              }
            }
          }
        }
      }
    `
  );

  let nodes = destinations.nodes;
  if (showExpeditionsOnly) {
    nodes = nodes.filter((n) => n.isExpeditionDestination == true);
  }

  const localizedNodes = localizeStaticQuery(nodes, language);

  if (showExpeditionsOnly) {
    //add FYC filter for expedition cruises
    const expeditionFYCFilter = `?toggle%5BcruiseType%5D=true`;
    return localizedNodes.map((d) => {
      return {
        ...d,
        fullPath: `${d.fullPath}${expeditionFYCFilter}`
      };
    });
  }

  return localizedNodes;
};

export default useStaticDestinationsData;
